(function () {
    const form = document.getElementById('news-search-form');
    if (!form) {
        return;
    }

    const input = form.querySelector('[name="q"]');
    const clearButton = form.querySelector('[data-news-search-clear]');
    let debounceTimer = null;

    const submitSearch = () => {
        if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
        } else {
            form.submit();
        }
    };

    input?.addEventListener('input', () => {
        window.clearTimeout(debounceTimer);
        debounceTimer = window.setTimeout(submitSearch, 300);
    });

    input?.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
            window.clearTimeout(debounceTimer);
            event.preventDefault();
            submitSearch();
        }
    });

    clearButton?.addEventListener('click', () => {
        if (!input) {
            return;
        }

        input.value = '';
        window.clearTimeout(debounceTimer);
        submitSearch();
    });
})();
